export default "__VITE_ASSET__4216468d__"